import { isCapriEnv } from '../constants/url';
export const APPROVER_ID: string = isCapriEnv
  ? 'e4cac2c1-bb34-4dbe-a44b-e4b211eaa53d'
  : '20d472c3-2089-4d49-95b0-4bae77cd1fce';
export const BIDDER_USER_ID: string = '54381e76-2f1a-4a5e-b1db-2714210d29b3';
export const CLIENT_ID: string = 'a0ac1cd2-54a2-11ee-8c99-0242ac120002';
export const LEAVE_APPROVER_ID: string = '20d472c3-2089-4d49-95b0-4bae77cd1fce';
export const VISIT_ID: string = 'acd8f50e-25c8-4550-8d46-b7db559f7676';
